import type { WorkScheduleWeek } from '@trinnvis/dabih-api-client';

export function forDayIndex(workScheduleWeek: WorkScheduleWeek, dayIndex: number) {
  switch (dayIndex) {
    case 0:
      return workScheduleWeek.monday;
    case 1:
      return workScheduleWeek.tuesday;
    case 2:
      return workScheduleWeek.wednesday;
    case 3:
      return workScheduleWeek.thursday;
    case 4:
      return workScheduleWeek.friday;
    case 5:
      return workScheduleWeek.saturday;
    case 6:
      return workScheduleWeek.sunday;
    default:
      throw new Error('Illegal index ' + dayIndex);
  }
}
